module.exports = __webpack_public_path__ + "static/media/Accenture.504c887f.png";